export const nomes = {
  total_aumentar: 'Total a aumentar',
  estoque_parametrizavel: 'Estoque ideal parametrizado',
  total_estoque: 'Estoque atual',
  diferenca: 'Diferença',
  total_reduzir: 'Total a reduzir',
}

export const cores = {
  total_aumentar: '#239ede',
  estoque_parametrizavel: '#69ce0d',
  total_estoque: '#f1f0f0',
  diferenca: '#ce15e5',
  total_reduzir: '#ff1010',
}
